"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MODE_EDIT = exports.MODE_ADD = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _peractoUi = require("@peracto/peracto-ui");

var _formik = require("formik");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faLock = require("@fortawesome/pro-regular-svg-icons/faLock");

var _faTrash = require("@fortawesome/pro-regular-svg-icons/faTrash");

var _faTimes = require("@fortawesome/pro-regular-svg-icons/faTimes");

var _faEdit = require("@fortawesome/pro-regular-svg-icons/faEdit");

var _faExclamationTriangle = require("@fortawesome/pro-regular-svg-icons/faExclamationTriangle");

var _reactToastify = require("react-toastify");

var _startCase = _interopRequireDefault(require("lodash/startCase"));

var _AddressForm = _interopRequireDefault(require("./AddressForm"));

var S = _interopRequireWildcard(require("./styled"));

var _client = require("@peracto/client");

var _peractoConfig = require("@peracto/peracto-config");

var _peractoHooks = require("@peracto/peracto-hooks");

var _peractoUser = require("@peracto/peracto-user");

var _util = require("./util");

var _excluded = ["mode", "values", "setFormData", "onSaveAddress", "testId"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var MODE_ADD = 'add';
exports.MODE_ADD = MODE_ADD;
var MODE_EDIT = 'edit';
exports.MODE_EDIT = MODE_EDIT;

var UserForm = function UserForm(_ref) {
  var _user$defaultBranch;

  var _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? MODE_EDIT : _ref$mode,
      values = _ref.values,
      _ref$setFormData = _ref.setFormData,
      setFormData = _ref$setFormData === void 0 ? function () {} : _ref$setFormData,
      onSaveAddress = _ref.onSaveAddress,
      testId = _ref.testId,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showUserDialog = _useState2[0],
      setShowUserDialog = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showPasswordReset = _useState4[0],
      setShowPasswordReset = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      sendingPasswordReset = _useState6[0],
      setSendingPasswordReset = _useState6[1];

  var _useState7 = (0, _react.useState)({}),
      _useState8 = _slicedToArray(_useState7, 2),
      visibleFields = _useState8[0],
      setVisibleFields = _useState8[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = _slicedToArray(_useState9, 2),
      customerGroups = _useState10[0],
      setCustomerGroups = _useState10[1];

  var _useState11 = (0, _react.useState)([]),
      _useState12 = _slicedToArray(_useState11, 2),
      branches = _useState12[0],
      setBranches = _useState12[1];

  var _useState13 = (0, _react.useState)([]),
      _useState14 = _slicedToArray(_useState13, 2),
      userGroups = _useState14[0],
      setUserGroups = _useState14[1];

  var _useState15 = (0, _react.useState)(),
      _useState16 = _slicedToArray(_useState15, 2),
      redirect = _useState16[0],
      setRedirect = _useState16[1];

  var _useClient = (0, _client.useClient)(),
      client = _useClient.client;

  var config = (0, _peractoConfig.useConfig)();

  var _config$get = config.get('features', {}),
      user = _config$get.user;

  var defaultBranch = (_user$defaultBranch = user === null || user === void 0 ? void 0 : user.defaultBranch) !== null && _user$defaultBranch !== void 0 ? _user$defaultBranch : false;

  var _useSettings = (0, _peractoHooks.useSettings)(),
      settingsValues = _useSettings.values;

  var user_types = settingsValues === null || settingsValues === void 0 ? void 0 : settingsValues.user_types;

  var onDelete = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _e$error, _e$error$body;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return client(_client.DELETE, 'users', {
                id: values.user.id
              });

            case 3:
              _reactToastify.toast.success('User deleted successfully!');

              setRedirect('/users');
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);

              _reactToastify.toast.error(_context.t0 !== null && _context.t0 !== void 0 && (_e$error = _context.t0.error) !== null && _e$error !== void 0 && (_e$error$body = _e$error.body) !== null && _e$error$body !== void 0 && _e$error$body.hasOwnProperty('hydra:description') ? _context.t0.error.body['hydra:description'] : 'Whoops, there was a problem...');

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function onDelete() {
      return _ref2.apply(this, arguments);
    };
  }();

  var onResetPassword = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _e$error2, _e$error2$body;

      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setSendingPasswordReset(true);
              _context2.prev = 1;
              _context2.next = 4;
              return client(_client.CREATE, 'users/reset-password', {
                data: {
                  email: values.user.email
                }
              });

            case 4:
              setShowPasswordReset(false);
              setSendingPasswordReset(false);

              _reactToastify.toast.success('Password reset email sent!');

              _context2.next = 14;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](1);
              console.error(_context2.t0);
              setSendingPasswordReset(false);

              _reactToastify.toast.error(_context2.t0 !== null && _context2.t0 !== void 0 && (_e$error2 = _context2.t0.error) !== null && _e$error2 !== void 0 && (_e$error2$body = _e$error2.body) !== null && _e$error2$body !== void 0 && _e$error2$body.hasOwnProperty('hydra:description') ? _context2.t0.error.body['hydra:description'] : 'Whoops, there was a problem...');

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 9]]);
    }));

    return function onResetPassword() {
      return _ref3.apply(this, arguments);
    };
  }();

  var fetchCustomerGroups = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var inputValue,
          _yield$client,
          data,
          values,
          _args3 = arguments;

      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              inputValue = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : '';
              _context3.next = 3;
              return client(_client.GET_LIST, 'customer-groups', {
                id: 'customer-groups',
                label: inputValue
              });

            case 3:
              _yield$client = _context3.sent;
              data = _yield$client.data;
              values = data.map(function (val) {
                return {
                  label: val.name,
                  value: val.id
                };
              });
              setCustomerGroups(values);
              return _context3.abrupt("return", values);

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function fetchCustomerGroups() {
      return _ref4.apply(this, arguments);
    };
  }();

  var fetchBranches = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var inputValue,
          _yield$client2,
          data,
          values,
          _args4 = arguments;

      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              inputValue = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : '';
              _context4.next = 3;
              return client(_client.GET_LIST, 'locations?locationTypes.type=branch', {
                id: 'locations',
                label: inputValue
              });

            case 3:
              _yield$client2 = _context4.sent;
              data = _yield$client2.data;
              values = data.map(function (val) {
                return {
                  label: val.name,
                  value: val.id
                };
              });
              setBranches(values);
              return _context4.abrupt("return", values);

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function fetchBranches() {
      return _ref5.apply(this, arguments);
    };
  }();

  var fetchUserGroups = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var inputValue,
          _yield$client3,
          data,
          values,
          _args5 = arguments;

      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              inputValue = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : '';
              _context5.next = 3;
              return client(_client.GET_LIST, 'user-groups', {
                id: 'user-groups',
                label: inputValue
              });

            case 3:
              _yield$client3 = _context5.sent;
              data = _yield$client3.data;
              values = data.map(function (val) {
                return {
                  label: val.name,
                  value: val.identifier
                };
              });
              setUserGroups(values);
              return _context5.abrupt("return", values);

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function fetchUserGroups() {
      return _ref6.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    if (user !== null && user !== void 0 && user.userGroups) {
      fetchUserGroups();
    } else {
      fetchCustomerGroups();
    }

    defaultBranch && fetchBranches();
  }, [user]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": testId
  }, redirect && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
    to: redirect
  }), mode === MODE_EDIT && /*#__PURE__*/_react["default"].createElement(_peractoUi.FormActions, null, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick() {
      return setShowPasswordReset(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faLock.faLock,
    className: "mr-2"
  }), "Reset Password"), /*#__PURE__*/_react["default"].createElement("a", {
    className: "text-danger",
    onClick: function onClick() {
      return setShowUserDialog(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faTrash.faTrash,
    className: "mr-2"
  }), "Delete User"))), /*#__PURE__*/_react["default"].createElement(_peractoUi.Form, _extends({
    autoComplete: "off",
    values: values
  }, props), /*#__PURE__*/_react["default"].createElement(_peractoUi.Group, {
    key: "customer",
    id: "customer",
    name: "Customer"
  }, mode === MODE_EDIT && /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex justify-content-between align-items-start"
  }, /*#__PURE__*/_react["default"].createElement("div", null, !visibleFields.customer && /*#__PURE__*/_react["default"].createElement(S.Address, null, /*#__PURE__*/_react["default"].createElement("p", {
    className: "address-name"
  }, values.user.firstName, " ", values.user.lastName), /*#__PURE__*/_react["default"].createElement("p", null, values.user.email), /*#__PURE__*/_react["default"].createElement("p", null, values.user.telephone), /*#__PURE__*/_react["default"].createElement("p", null, values.user.roles.map(function (val, idx) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: "role-".concat(idx)
    }, idx > 0 ? ', ' : '', _peractoUser.roleValues[val]);
  })))), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    role: "button",
    className: "p-0 btn btn-link",
    onClick: function onClick() {
      setVisibleFields(_objectSpread(_objectSpread({}, visibleFields), {}, {
        customer: !visibleFields.customer
      }));
    }
  }, visibleFields.customer ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faTimes.faTimes,
    className: "mr-2"
  }), "Close") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faEdit.faEdit,
    className: "mr-2"
  }), "Edit"))), (mode === MODE_ADD || visibleFields.customer) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
    name: "user.title",
    label: "Title",
    options: _util.titles,
    placeholder: "Select a title",
    testId: "title",
    testIdItems: "title__item",
    testIdIndex: 0
  }), /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
    name: "user.firstName",
    label: "First name",
    required: true,
    autoComplete: "first-name",
    testId: "firstname"
  }), /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
    name: "user.lastName",
    label: "Last name",
    required: true,
    autoComplete: "last-name",
    testId: "lastname"
  }), /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
    name: "user.email",
    label: "Email",
    required: true,
    autoComplete: "email",
    testId: "email"
  }), /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
    name: "user.telephone",
    label: "Telephone",
    testId: "telephone"
  }), /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
    name: "user.mobile",
    label: "Mobile Number",
    testId: "mobile"
  }), /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
    name: "user.businessTelephoneNumber",
    label: "Business Telephone",
    testId: "business-telephone"
  }), defaultBranch && (branches === null || branches === void 0 ? void 0 : branches.length) > 0 && /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "user.defaultBranch"
  }, function (_ref7) {
    var field = _ref7.field,
        form = _ref7.form;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react["default"].createElement("label", null, "Default Branch"), /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
      name: field.name,
      className: "w-100",
      isSearchable: true,
      onChange: function onChange(option) {
        form.setFieldValue(field.name, option.value);
      },
      options: branches,
      placeholder: "Search for Branches...",
      testId: "branches",
      testIdItems: "branches__item",
      testIdIndex: 1,
      allowClear: true
    }));
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "mb-1"
  }, "Date of Birth"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-md-3"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
    name: "user.splitDateOfBirth.day",
    label: "Day",
    defaultValue: _util.defaultSelectValue,
    options: [_util.defaultSelectValue].concat(_toConsumableArray(_util.days.map(function (day) {
      return {
        label: day,
        value: day
      };
    })))
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-md-3"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
    name: "user.splitDateOfBirth.month",
    label: "Month",
    defaultValue: _util.defaultSelectValue,
    options: [_util.defaultSelectValue].concat(_toConsumableArray(_util.months))
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-md-3"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
    name: "user.splitDateOfBirth.year",
    label: "Year",
    defaultValue: _util.defaultSelectValue,
    options: [_util.defaultSelectValue].concat(_toConsumableArray(_util.years.map(function (year) {
      return {
        label: year,
        value: year
      };
    })))
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-3 d-flex"
  }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "user.splitDateOfBirth"
  }, function (_ref8) {
    var form = _ref8.form;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
      className: "px-0 mt-2 btn btn-link",
      type: "button",
      onClick: function onClick(e) {
        e.preventDefault();
        form.setFieldValue('user.splitDateOfBirth.day', '');
        form.setFieldValue('user.splitDateOfBirth.month', '');
        form.setFieldValue('user.splitDateOfBirth.year', '');
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faTimes.faTimes,
      className: "mr-2"
    }), "Clear Value"));
  }))), /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
    name: "user.enabled",
    label: "Account Status",
    options: [{
      label: 'Enabled',
      value: true
    }, {
      label: 'Disabled',
      value: false
    }],
    testId: "account-status",
    testIdItems: "account-status__item"
  }), /*#__PURE__*/_react["default"].createElement(_peractoUi.Tags, {
    name: "user.roles",
    label: "Roles",
    options: _util.roles,
    testId: "roles",
    testIdItems: "roles__item"
  }), user !== null && user !== void 0 && user.userGroups ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (userGroups === null || userGroups === void 0 ? void 0 : userGroups.length) > 0 && /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "user.userGroup"
  }, function (_ref9) {
    var _React$createElement;

    var field = _ref9.field,
        form = _ref9.form;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react["default"].createElement("label", null, "User Group"), /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, (_React$createElement = {
      name: field.name,
      className: "w-100",
      isSearchable: true,
      onChange: function onChange(option) {
        form.setFieldValue(field.name, option.value);
      },
      defaultValue: {
        label: 'Search for User Groups...',
        value: null
      },
      options: userGroups
    }, _defineProperty(_React$createElement, "defaultValue", {
      label: 'Search for User Groups...',
      value: null
    }), _defineProperty(_React$createElement, "placeholder", "Search for User Groups..."), _defineProperty(_React$createElement, "testId", "user-groups"), _defineProperty(_React$createElement, "testIdItems", "user-groups__item"), _defineProperty(_React$createElement, "testIdIndex", 1), _defineProperty(_React$createElement, "allowClear", true), _React$createElement)));
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (customerGroups === null || customerGroups === void 0 ? void 0 : customerGroups.length) > 0 && /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "user.customerGroup"
  }, function (_ref10) {
    var field = _ref10.field,
        form = _ref10.form;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react["default"].createElement("label", null, "Customer Group"), /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
      name: field.name,
      className: "w-100",
      isSearchable: true,
      onChange: function onChange(option) {
        form.setFieldValue(field.name, option.value);
      },
      options: customerGroups,
      placeholder: "Search for Customer Groups...",
      testId: "customer-groups",
      testIdItems: "customer-groups__item",
      testIdIndex: 1,
      allowClear: true
    }));
  })), (user_types === null || user_types === void 0 ? void 0 : user_types.length) > 0 && /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "user.type"
  }, function (_ref11) {
    var field = _ref11.field,
        form = _ref11.form;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react["default"].createElement("label", null, "Customer Type"), /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
      name: field.name,
      className: "w-100",
      isSearchable: true,
      onChange: function onChange(option) {
        form.setFieldValue(field.name, option.value);
      },
      options: user_types.map(function (type) {
        return {
          label: (0, _startCase["default"])(type),
          value: type
        };
      }),
      placeholder: "Please Select",
      testId: "user-types",
      testIdItems: "user-types__type",
      testIdIndex: 1,
      allowClear: true
    }));
  }), /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
    name: "user.companyName",
    label: "Company Name",
    testId: "company-name"
  }), (user === null || user === void 0 ? void 0 : user.companySettings) && /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
    name: "user.accountNumber",
    label: "Account Number",
    testId: "account-number"
  }), /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
    name: "user.currency",
    label: "Currency",
    options: [{
      label: 'GBP',
      value: 'GBP'
    }, {
      label: 'Euro',
      value: 'EUR'
    }],
    placeholder: "Select a currency",
    testId: "currency",
    testIdItems: "currency__item",
    testIdIndex: 0
  }), (user === null || user === void 0 ? void 0 : user.manageVAT) && /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
    name: "user.vat",
    label: "Include VAT",
    options: [{
      label: 'Yes',
      value: true
    }, {
      label: 'No',
      value: false
    }],
    placeholder: "Include VAT",
    testId: "vat",
    testIdItems: "vat__item"
  }), !(user !== null && user !== void 0 && user.hideCreditTerms) && /*#__PURE__*/_react["default"].createElement(_peractoUi.Checkbox, {
    name: "user.hasCreditTerms",
    label: "User has Credit Terms"
  })))), mode === MODE_EDIT && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AddressForm["default"], _extends({
    values: values,
    visibleFields: visibleFields,
    setVisibleFields: setVisibleFields,
    setFormData: setFormData,
    titles: _util.titles,
    onSaveAddress: onSaveAddress
  }, props)), /*#__PURE__*/_react["default"].createElement(_peractoUi.Modal, {
    isVisible: showUserDialog,
    title: "Delete User",
    close: function close() {
      return setShowUserDialog(false);
    },
    buttons: [{
      type: 'btn-outline-secondary',
      text: 'Close',
      action: function action() {
        return setShowUserDialog(false);
      }
    }, {
      type: 'btn-danger',
      text: 'Delete User',
      action: function action() {
        return onDelete();
      }
    }]
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faExclamationTriangle.faExclamationTriangle,
    size: "4x",
    className: "mb-4 d-block"
  }), "Are you sure you would like to permanently delete the account of", ' ', values.user.email, "? Deleted users cannot be recovered."), /*#__PURE__*/_react["default"].createElement(_peractoUi.Modal, {
    isVisible: showPasswordReset,
    title: "Reset Password",
    close: function close() {
      return setShowPasswordReset(false);
    },
    buttons: [{
      type: 'btn-outline-secondary',
      text: 'Cancel',
      action: function action() {
        return setShowPasswordReset(false);
      }
    }, {
      type: 'btn-success',
      text: sendingPasswordReset ? 'Sending Email...' : 'Send Email',
      disabled: sendingPasswordReset,
      action: function action() {
        return onResetPassword();
      }
    }]
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faExclamationTriangle.faExclamationTriangle,
    size: "4x",
    className: "mb-4 d-block"
  }), "Are you sure you would like to generate a reset password email for", ' ', values.user.email, "?"))));
};

UserForm.displayName = 'UserForm';
UserForm.propTypes = {
  values: _propTypes["default"].object,
  mode: _propTypes["default"].oneOf([MODE_ADD, MODE_EDIT]),
  schema: _propTypes["default"].object.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  setFormData: _propTypes["default"].func,
  countries: _propTypes["default"].array
};
var _default = UserForm;
exports["default"] = _default;